<template>
	<div>
		<breadcrumb :routerList="[{to:'/contract-detail',title:'合同管理'},{title:'合同详情'}]"/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formLine weekplandetail">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						<el-form-item label="合同名称" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractName"></el-input>
						</el-form-item>
					  <el-form-item label="合同类型" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractCatecoryName"></el-input>
					  </el-form-item>
            <el-form-item v-if="'CT-ZL' == formInline.contractCatecory" label="合同订单类型" class="h-elformWrap-2">
              <el-select v-model="formInline.nwSale" :v="formInline.nwSale" placeholder="请选择" :disabled="true">
                <el-option label="内销订单" value="1"></el-option>
                <el-option label="外销订单" value="2"></el-option>
              </el-select>
            </el-form-item>
						<el-form-item label="商务合同号" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.businessContractCode"></el-input>
						</el-form-item>
					  <el-form-item label="关联项目" class="h-elformWrap-2" v-if="!zlflag && !dlsflag">
						<el-input readonly v-model="formInline.pid"></el-input>
					  </el-form-item>
					  <el-form-item :label="customerlabel" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.customerName"></el-input>
					  </el-form-item>
					 <!-- <el-form-item label="产品大类" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productType"></el-input>
					  </el-form-item>
					  <el-form-item label="产品型号" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productCode"></el-input>
					  </el-form-item>
					  <el-form-item label="产品名称" class="h-elformWrap-2" v-if="zlflag">
						<el-input readonly v-model="formInline.productName"></el-input>
					  </el-form-item>
					  <el-form-item label="租赁数量" class="h-elformWrap-2" prop="rentNum" v-if="zlflag">
						<el-input readonly v-model="formInline.rentNum"></el-input>
					  </el-form-item> -->
					  <el-form-item label="租赁时间" class="h-elformWrap-2" prop="rentTime" v-if="zlflag && !jzxFlag">
						  <el-col class="yearIcon">
							  <el-input readonly v-model="formInline.rentTime">
							  </el-input>
						  </el-col>
					  </el-form-item>
					  <!--<el-form-item label="保修时间" class="h-elformWrap-2" prop="guaranteeTime" v-if="zlflag">-->
						<!--<el-col class="yearIcon">-->
							<!--<el-input readonly v-model="formInline.guaranteeTime">-->
							<!--</el-input>-->
						<!--</el-col>-->
						<!--</el-form-item>-->
					  <el-form-item label="LEG合同编号" class="h-elformWrap-2" v-if="formInline.contractType===1 && !cgflag">
					  	<el-input readonly v-model="formInline.contractCode"></el-input>
					  </el-form-item>
					  <el-form-item label="销售渠道" class="h-elformWrap-2" v-if="!cgflag&&!zlflag">
						<el-input readonly v-model="formInline.salechannelName"></el-input>
					  </el-form-item>
					  <el-form-item label="合同金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag && !jzxFlag">
						<el-input readonly v-model="formInline.contractAmount"></el-input>
					  </el-form-item>
					   <el-form-item label="合同状态" class="h-elformWrap-2" v-if="formInline.contractType===1&&!cgflag">
						<el-input readonly v-model="formInline.contractStatus"></el-input>
					  </el-form-item>
						<el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype" v-if="zlflag">
							<el-select v-model="formInline.zltype" :v="formInline.zltype" disabled placeholder="请选择" @change="selectZlProduct1()">
								<el-option v-for="(item) in zltypeList"
										   :key="item.code"
										   :label="item.name"
										   :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
            <el-form-item label="货币种类" class="h-elformWrap-2" prop="zltype" v-if="'CT-ZL' == formInline.contractCatecory && '3' == formInline.zltype">
              <brselectlazy category="YLCurrency" :v="formInline.currencyCode" v-model="formInline.currencyCode" :clearable="false"
                            :disabled="true"/>
            </el-form-item>
						<el-form-item label="租赁方式" class="h-elformWrap-2"  v-if="zlflag && !jzxFlag" prop="rentType">
							<el-select v-model="formInline.rentType" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="Round Trip" value="roundtrip"></el-option>
								<el-option label="长期" value="longterm"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="租赁天数" class="h-elformWrap-2" v-if="jzxFlag">
							<el-input readonly v-model="formInline.rentTime"></el-input>
						</el-form-item>
					   <el-form-item label="合同开始时间" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractStarttime"></el-input>
					  </el-form-item>
					  <el-form-item label="合同结束时间" class="h-elformWrap-2">
						<el-input readonly v-model="formInline.contractEndtime"></el-input>
					  </el-form-item>
						<el-form-item label="付款日期" class="h-elformWrap-2">
							<el-input readonly v-model="formInline.payDate"></el-input>
						</el-form-item>
						<el-form-item label="是否附加损坏豁免" class="h-elformWrap-2"  v-if="jzxFlag" prop="isShhm">
							<el-select v-model="formInline.isShhm" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="是" value=1></el-option>
								<el-option label="否" value=0></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="提箱地点"  v-if="jzxFlag" class="h-elformWrap-2">
							<el-input v-model="formInline.rentPlace" readonly></el-input>
						</el-form-item>
						<el-form-item label="还箱地点"  v-if="jzxFlag" class="h-elformWrap-2">
							<el-input v-model="formInline.returnPlace" readonly></el-input>
						</el-form-item>
						<el-form-item label="是否加急"  v-if="jzxFlag" class="h-elformWrap-2" prop="isJj">
							<el-select v-model="formInline.isJj" placeholder="请选择"
									   :clearable="true" filterable disabled>
								<el-option label="是" value=1></el-option>
								<el-option label="否" value=0></el-option>
							</el-select>
						</el-form-item>
					    <!--<el-form-item label="押金金额" class="h-elformWrap-2 h-moneyIcon" v-if="!cgflag">-->
						<!--<el-input readonly v-model="formInline.contractCashPledge"></el-input>-->
					  <!--</el-form-item>-->
						<el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype" v-if="zlflag">
							<el-select v-model="formInline.zltype" :v="formInline.zltype" placeholder="请选择" @change="selectZlProduct1()">
								<el-option v-for="(item) in zltypeList"
										   :key="item.code"
										   :label="item.name"
										   :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
					  <el-form-item label="付款条件" class="h-elformWrap-1" v-if="!cgflag && !zlflag && !bzflag&&!dlsflag">
					  </el-form-item>
					  <el-form-item label="物流方式" class="h-elformWrap-2" v-if="cgflag">
						<el-input readonly v-if="formInline.wuliufangshi==1" value="海尔自有物流"></el-input>
						<el-input readonly v-if="formInline.wuliufangshi==2" value="供应商直发"></el-input>
						<el-input readonly v-if="formInline.wuliufangshi==3" value="海尔自有物流和供应商直发皆可"></el-input>
					  </el-form-item>
					</el-form>
				</div>
				<div class="h-pieceInCon3 h-mrt0 h-mrl100" v-if="!cgflag&&!zlflag&&!bzflag&&!dlsflag">
					<div class="h-formLine h-mrb-38">
						<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
						  <el-form-item label="现金" class="h-elformWrap-2">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input readonly v-model="formInline.cashRatio"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input readonly v-model="formInline.cashAmount"></el-input>
							</el-col>
						  </el-form-item>
						  <el-form-item label="信贷" class="h-elformWrap-2">
							<el-col :span="10" class="h-percentageIcon">
							  <el-input readonly v-model="formInline.creditRatio"></el-input>
							</el-col>
							<el-col class="line h-txtCenter h-zIcon" :span="4"><img src="../../../assets/images/h-zhunhua-icon.png"></el-col>
							<el-col :span="10" class="h-moneyIcon2">
							  <el-input readonly v-model="formInline.creditAmount"></el-input>
							</el-col>
						  </el-form-item>
						</el-form>
					</div>
				</div>
				<div v-if="cgflag">
				<div class="h-pieceTitle2" style="margin:5px 0 16px 10px">
					<h1>产品信息</h1>
				</div>
				<el-form ref="form4" :model="formInline">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.productList"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        label="#" width="40">
				        </el-table-column>
				        <el-table-column
				        prop="productId"
				        label="产品型号" width="160">
				        </el-table-column>
				        <el-table-column
				        prop="productName"
						:show-overflow-tooltip="true"
				        label="产品名称" width="150">
				        </el-table-column>
					 	<el-table-column
						prop="oemDesc"
						:show-overflow-tooltip="true"
						label="规格型号" width="150">
						</el-table-column>
				        <el-table-column
				        prop="unitPrice"
				        label="产品价格" width="140">
				        </el-table-column>
					 <el-table-column
							 prop="currency"
							 min-width="100"
							 :show-overflow-tooltip="true"
							 label="币种">
						 <template slot-scope="scope">
							 {{scope.row.currency | dictname('YLCurrency')}}
						 </template>
					 </el-table-column>
				        <el-table-column
				        prop="shuilv"
				        label="发票税率" width="140">
				            <template scope="scope">
								<brselect category="cgshuilv" :v="scope.row.shuilv" disabled v-model="scope.row.shuilv" />
				            </template>
				        </el-table-column>
					 <el-table-column
							 prop="cgjingli"
							 label="采购经理">
						 <template scope="scope">
							 <brselect :multiple="true" category="cg_manage" v-model="scope.row.cgjingli" :v="scope.row.cgjingli" disabled/>
						 </template>
					 </el-table-column>
				    </el-table>
					</el-form>
				</div>
				<div v-if="zlflag">
					<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
						<h1>租赁型号</h1>
					</div>
					<el-table
				        ref="multipleTable"
				        :data="formInline.zlList"
				        style="width: 100%"
				        >
				        <el-table-column
							type="index"
							width="40"
							label="#">
				        </el-table-column>
						<el-table-column
							prop="productType"
							:show-overflow-tooltip="true"
							v-if="!jzxFlag"
							label="产品大类">
						</el-table-column>
						<el-table-column
							prop="productCode"
							:show-overflow-tooltip="true"
							label="产品型号">
						</el-table-column>
						<el-table-column
							prop="productName"
							:show-overflow-tooltip="true"
							label="产品名称">
						</el-table-column>
						<el-table-column
								prop="priceType"
								label="费用名称"
								:show-overflow-tooltip="true">
							<template scope="scope">
								{{scope.row.priceType|dictname('price_type') }}
							</template>
						</el-table-column>
						<el-table-column
								prop="productUnitPrice"
								label="单价">
						</el-table-column>
						<el-table-column
								prop="rentNum"
								label="租赁数量">
						</el-table-column>
						<el-table-column
								prop="productTotalPrice"
								label="金额">
						</el-table-column>
				    </el-table>
				</div>
				<div v-if="cgflag || (zlflag && formInline.zltype == '1')">
					<div class="h-pieceTitle2" style="margin:25px 0 16px 10px">
						<h1>付款节点</h1>
					</div>
				<el-form ref="form3">
				 <el-table
				        ref="multipleTable"
				        :data="formInline.paymentList"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        width="40"
				        label="#">
				        </el-table-column>
				        <el-table-column
				        prop="nodeName"
				        label="节点名称"
						 :show-overflow-tooltip="true">
				            <template scope="scope">
								<dictname category="payment_node" :v="scope.row.nodeName"/>
							</template>
				        </el-table-column>
				        <el-table-column
				        prop="paymentRatio"
				        label="付款比例(%)" width="200">
				            <template scope="scope">
								{{scope.row.paymentRatio}}
				            </template>
				        </el-table-column>
						<el-table-column
						prop="paymentAmount"
						v-if="zlflag"
						label="开票金额" width="200">
						    <template scope="scope">
								{{scope.row.paymentAmount}}
						    </template>
						</el-table-column>
						<el-table-column
						prop="netValue"
						v-if="zlflag"
						label="净价值" width="200">
						    <template scope="scope">
								{{scope.row.netValue}}
						    </template>
						</el-table-column>
				        <!--<el-table-column
				        prop="paymentDays"
				        label="账期(天)"
				        width="200">
				            <template scope="scope">
								{{scope.row.paymentDays}}
				            </template>
				        </el-table-column>
				        <el-table-column
				        prop="isNeedcred"
				        label="是否需要凭证"
				        width="200">
				            <template scope="scope">
								<span v-if="scope.row.isNeedcred==1">是</span>
								<span v-if="scope.row.isNeedcred==0">否</span>
				            </template>
				        </el-table-column>-->
				    </el-table>
					</el-form>
				</div>
				<div v-if="zlflag && formInline.zltype == '1'" style="margin-top: 0.3rem;">
				<el-form ref="form3" :model="formInline" >
				 <el-table
				        ref="multipleTable"
				        :data="formInline.fukuanobj"
				        style="width: 100%"
				        >
				        <el-table-column
				        type="index"
				        width="40"
				        label="#">
				        </el-table-column>
				        <el-table-column
				        prop="nodeName"
				        label="节点名称">
				          <template scope="scope">
				           	{{scope.row.nodeName}}
				           	</template>
				        </el-table-column>
				        <el-table-column
				        prop="paymentRatio"
				        label="付款比例(%)" width="200">
				        <template scope="scope">
				            	{{scope.row.paymentRatio}}
				            	</template>
				        </el-table-column>
						<el-table-column
						prop="paymentAmount"
						label="付款金额(元)" width="200">
						<template scope="scope">
						  {{scope.row.paymentAmount}}
						  </template>
						</el-table-column>
						<el-table-column
						prop="netValue"
						label="净价值(元)" width="200">
						<template scope="scope">
						     {{scope.row.netValue}}
						     </template>
						</el-table-column>
				        <el-table-column
				        prop="paymentDays"
				        label="账期(天)"
				        width="150">
				        <template scope="scope">
				             {{scope.row.paymentDays}}
				             </template>
				        </el-table-column>
				    </el-table>
					</el-form>
				</div>
				<div class="h-formLine h-mrt40 weekplandetail1">
					<el-form :model="formInline" label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
					  <el-form-item label="合同附件" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2">
<!--						<brupload :refid="this.contractId" reftype="合同附件"></brupload>-->

						  <brupload
								  :refid="this.contractId"
								  style="display:none"
								  reftype="合同附件"
						  >
						  </brupload>
						  <div class="new-yulan">
							  <ul v-for="(item,index) in fileList" :key="index">
								  <li><a :href=" 'https://oms.haierbiomedical.com/' + item.saveurl" target="_blank" ><h3><i class="el-icon-document"></i>{{item.name}}<span>{{item.cdate}}</span></h3></a></li>
							  </ul>
						  </div>
						  <el-dialog :visible.sync="dialogVisible">
							  <img width="100%" :src="dialogImageUrl" alt="">
						  </el-dialog>
					  </el-form-item>
<!--						<el-form-item label="合同附件" class="h-elformWrap-2 h-formRbtnOut h-formRbtnOut2" v-if="!dlsflag">
							<brupload :refid="this.contractId" reftype="合同附件"></brupload>
						</el-form-item>-->
					</el-form>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
				<router-link :to="{path:'/contract-list'}">
					<el-button class="h-btn h-bBtn h-bgblueQ2">返回</el-button>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import ss from "../../../api/SystemService";
	import util from "../../../utils/util";
	import uploaddown from '../../../utils/updownfile';
    export default {
        name:'leftMenu',
        data() {
            return {
                zltypeList:[
                    {code:"1",name:"房屋"},
                    {code:"2",name:"疫苗车"},
					{code:"3",name:"集装箱"}
                ],
				customerlabel:"客户名称",
				cgflag:false,
				zlflag:false,
				bzflag:false,
				dlsflag:false,
				//表单
				formInline:{},
				contractId:this.$route.query.key,
				//多选
				checkList:[],
				fileList:[],
				zlxh:[
					{
						productType:'NA4',
						productCode:'BF0260B04',
						productName:'DW-25W198',
						rentNum:'8'
					}
				],
				fukuanobj:[
					{
						nodeName:"",
						newflag:false,
						paymentRatio:"",
						paymentAmount:"",
						netValue:"",
						paymentDays:"",
						billPayMonty:""
					}
				],
				jzxFlag:false,
				fileList:[],
            }
        },
        methods: {

        },
		mounted() {
			ss.contractService.detail(this.contractId).then(rd => {
				this.formInline = rd.obj;
				// console.log(this.formInline);
				if (this.formInline.contractCatecory == "CT-CG") {
					this.cgflag = true;
					this.customerlabel = "供应商名称";
				} else if (this.formInline.contractCatecory == "CT-ZL") {
					rd.obj['fukuanobj'] = [];
						this.formInline = rd.obj;

						this.formInline.fukuanobj.push({nodeName:"押金",paymentRatio:rd.obj.contractCashRadio,paymentDays:rd.obj.contractCashDays,
									newflag:false,netValue:rd.obj.contractCashNetValue,paymentAmount:rd.obj.contractCashPledge});
					console.log(1)
					this.zlflag = true;
					if(this.formInline.zltype == '3'){
						this.jzxFlag = true;
						if(this.formInline.isShhm == 1){
							this.formInline.isShhm = '1';
						}else if(this.formInline.isShhm == 0){
							this.formInline.isShhm = '0';
						}
						if(this.formInline.isJj == 1){
							this.formInline.isJj = '1';
						}else if(this.formInline.isJj == 0){
							this.formInline.isJj = '0';
						}
					}
					console.log(2)
				} else if (this.formInline.contractCatecory == "CT-BZ") {
					this.bzflag = true;
				} else if(this.formInline.contractCatecory == "CT-DLS-KJ"){
					this.dlsflag = true;
				}
				//获取附件相关信息
				var yuming =window.location.host
				var  refid = this.contractId
				// console.log(this.refid)
				uploaddown.listdownfile({refid:this.contractId, reftype: '合同附件'}).then(res => {
					console.log(res, '合同附件');
					this.fileList = res.obj
				})
			});
		}
    }
</script>

<style scoped>
.texts{
	color: #2a89d6;
	font-size: 18px;
	text-decoration: underline
}
</style>
<style>
/* .h-formbLine .el-form-item__label{
	width: 18%;
} */
.yearIcon .el-input:after {
  content: '年';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail .h-formbLine .el-form-item__label{
	width: 34%;
	text-align: right;
}
.weekplandetail .h-formbLine .el-form-item__content{
	width: 66%;
}
.weekplandetail .h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}
.weekplandetail .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 10.4%;
}
.weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 89.6%;
}
.weekplandetail2 .h-formbLine .h-elformWrap-2{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__label{
	width: 22.4%;
	vertical-align: middle;
}
.weekplandetail2 .h-formbLine .h-elformWrap-2 .el-form-item__content{
	width: 77.6%;
}
.weekplandetail1 .h-formbLine .h-elformWrap-2{
	width: 100%;
	padding-right: 0.5rem
}
.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__label{
	width: 7%;
	vertical-align: middle;
}
.weekplandetail1 .h-formbLine .h-elformWrap-2 .el-form-item__content{
	width: 93%;
}
.new-yulan{
	width: 100%;
	margin: 0 auto;
}
.new-yulan ul li{
	padding:5px 0
}
.new-yulan ul li h3{
	text-align: left;
	font-weight: 400;
	color: #0e75e9;
	font-size: 14px
}
.new-yulan ul li h3 i{
	padding: 0 5px;
	color: #606266
}
.new-yulan ul li h3 span{
	text-align: right;
	color: #606266;
	float: right;
	font-size: 13px
}
</style>
